export class UpdateFleetConfigurationRequest {
    fleetId?: string;
    state?: string;
    accessPolicy?: string;
    priority?: number;
    minLaunchCapacity?: number;
}